import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, DestroyRef, OnInit, ViewContainerRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { InvoiceFormComponent } from '../../components/invoice/invoice-form/invoice-form.component';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { InvoiceService } from '../../services/invoice.service';
import { ModalService } from '../../services/modal/modal.service';
import { Utils } from '../../utils/utils';

@Component({
  selector: 'app-create-invoice',
  imports: [CommonModule, ReactiveFormsModule, InvoiceFormComponent],
  templateUrl: './create-invoice.component.html',
  styleUrl: './create-invoice.component.scss',
})
export class CreateInvoiceComponent implements OnInit {
  buttonText = 'Create';

  errorProvider: Subject<string | undefined> = new Subject();
  submittingProvider: Subject<boolean> = new Subject();
  public form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private invoiceService: InvoiceService,
    private modalService: ModalService,
    private vcr: ViewContainerRef,
    private router: Router,
    private destroyRef: DestroyRef,
    private authService: AuthenticationService
  ) {
    this.form = fb.group({
      partner: fb.control(null, Validators.required),
      invoiceNumber: fb.control(1, Validators.required),
      status: fb.control(null, Validators.required),
      date: fb.control(Utils.today(), Validators.required),
      deliveryDate: fb.control(Utils.today(), Validators.required),
      deadline: fb.control(Utils.todayPlusAWeek(), Validators.required),
      amount: fb.control(0, Validators.required),
      article: fb.control(null),
      articles: fb.array([], Validators.required),
    });
  }

  ngOnInit(): void {
    this.invoiceService
      .getCurrentInvoiceNumber(new Date().getFullYear())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (resp) =>
          this.form.get('invoiceNumber')?.setValue(resp.invoiceNumber),
        error: (err: HttpErrorResponse) => {
          if (err.status == 401) {
            this.authService.logout();
          } else {
            this.modalService.showErrorDialog(this.vcr, err.error.message);
          }
        },
      });
  }

  createInvoice() {
    if (this.form.valid) {
      this.errorProvider.next(undefined);
      this.submittingProvider.next(true);

      this.invoiceService
        .createInvoice(this.form.value)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (resp) => {
            this.submittingProvider.next(false);
            this.router.navigateByUrl('dashboard/invoices');
          },
          error: (err: HttpErrorResponse) => {
            this.submittingProvider.next(false);
            this.modalService.showErrorDialog(this.vcr, err.error.message);
          },
        });
    } else {
      this.errorProvider.next('Please fill all field properly.');
    }
  }
}
